<template>
<div>
    <NavigationMenu />

    <header class="bg-gradient-to-r from-gray-700 to-gray-600 shadow-lg">
      <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-center gap-3">
          <div class="flex items-center justify-center w-12 h-12 rounded-xl bg-white bg-opacity-20 backdrop-blur-sm">
            <i class="fas fa-users-cog text-2xl text-white"></i>
          </div>
          <div class="text-center sm:text-left">
            <h1 class="text-3xl font-bold text-white">
              Gerenciar Usuários
            </h1>
            <p class="hidden sm:block text-gray-100 text-sm mt-0.5">
              Editar informações do usuário
            </p>
          </div>
        </div>
      </div>
    </header>

    <div class="container mx-auto lg:flex mt-4 justify-between px-2 sm:p-0 sm:mt-4">
        <NavigationUsers />
        
        <div class="w-full sm:w-9/12 mx-auto mr-0">
          <!-- Card moderno para o formulário -->
          <div class="bg-white rounded-xl shadow-lg overflow-hidden">
            <!-- Header do card -->
            <div class="border-b border-gray-200 bg-gray-50 px-6 py-4">
              <div class="flex items-center gap-2">
                <i class="fas fa-user-edit text-gray-600 text-xl"></i>
                <div>
                  <h2 class="text-xl font-bold text-gray-900">
                    {{ !this.userId ? '➕ Cadastrar' : '✏️ Atualizar' }} Usuário
                  </h2>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ !this.userId ? 'Preencha os dados do novo usuário' : 'Edite as informações do usuário' }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Formulário -->
            <form id="user-form" @submit="submitForm" class="p-6">
              <div class="max-w-2xl mx-auto space-y-6">
                <!-- Campo Nome -->
                <div class="space-y-2">
                  <label class="block text-sm font-medium text-gray-700">
                    Nome <span class="text-red-500">*</span>
                  </label>
                  <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i class="fas fa-user text-gray-400"></i>
                    </div>
                    <input 
                      v-model="user.name" 
                      type="text" 
                      required
                      class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 text-sm transition-colors duration-150"
                      placeholder="Digite o nome completo">
                  </div>
                </div>

                <!-- Campo Email -->
                <div class="space-y-2">
                  <label class="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <div class="relative">
                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <i class="fas fa-envelope text-gray-400"></i>
                    </div>
                    <input 
                      v-model="user.email" 
                      type="email" 
                      class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-gray-500 focus:border-gray-500 text-sm transition-colors duration-150"
                      placeholder="email@exemplo.com">
                  </div>
                </div>

                <!-- Campo Permissões -->
                <div class="space-y-3">
                  <label class="block text-sm font-medium text-gray-700">
                    Permissões
                  </label>
                  <div class="bg-gray-50 rounded-lg p-4 space-y-3">
                    <!-- SuperAdmin -->
                    <div class="flex items-center p-3 hover:bg-white rounded-lg transition-colors duration-150">
                      <input 
                        id="superadmin" 
                        v-model="this.user.rules" 
                        type="checkbox" 
                        value="SuperAdmin"  
                        class="h-5 w-5 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-500 transition-colors duration-150">
                      <label for="superadmin" class="ml-3 flex-1">
                        <span class="block text-sm font-medium text-gray-900">Super Admin</span>
                        <span class="block text-xs text-gray-500">Acesso total ao sistema</span>
                      </label>
                    </div>

                    <!-- Admin Futebol -->
                    <div class="flex items-center p-3 hover:bg-white rounded-lg transition-colors duration-150">
                      <input 
                        id="adminfutebol" 
                        v-model="this.user.rules" 
                        type="checkbox" 
                        value="AdminFutebol" 
                        class="h-5 w-5 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-500 transition-colors duration-150">
                      <label for="adminfutebol" class="ml-3 flex-1">
                        <span class="block text-sm font-medium text-gray-900">Admin Futebol</span>
                        <span class="block text-xs text-gray-500">Gerenciar seção de futebol</span>
                      </label>
                    </div>

                    <!-- Admin Bolão -->
                    <div class="flex items-center p-3 hover:bg-white rounded-lg transition-colors duration-150">
                      <input 
                        id="adminbolao" 
                        v-model="this.user.rules" 
                        type="checkbox" 
                        value="AdminBolao"  
                        class="h-5 w-5 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-500 transition-colors duration-150">
                      <label for="adminbolao" class="ml-3 flex-1">
                        <span class="block text-sm font-medium text-gray-900">Admin Bolão</span>
                        <span class="block text-xs text-gray-500">Gerenciar bolão e palpites</span>
                      </label>
                    </div>

                    <!-- User Bolão -->
                    <div class="flex items-center p-3 hover:bg-white rounded-lg transition-colors duration-150">
                      <input 
                        id="userbolao" 
                        v-model="this.user.rules" 
                        type="checkbox" 
                        value="UserBolao"  
                        class="h-5 w-5 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-500 transition-colors duration-150">
                      <label for="userbolao" class="ml-3 flex-1">
                        <span class="block text-sm font-medium text-gray-900">User Bolão</span>
                        <span class="block text-xs text-gray-500">Participar do bolão</span>
                      </label>
                    </div>

                    <!-- User Futebol -->
                    <div class="flex items-center p-3 hover:bg-white rounded-lg transition-colors duration-150">
                      <input 
                        id="userfutebol" 
                        v-model="this.user.rules" 
                        type="checkbox" 
                        value="UserFutebol"  
                        class="h-5 w-5 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-500 transition-colors duration-150">
                      <label for="userfutebol" class="ml-3 flex-1">
                        <span class="block text-sm font-medium text-gray-900">User Futebol</span>
                        <span class="block text-xs text-gray-500">Acessar seção de futebol</span>
                      </label>
                    </div>

                    <!-- User -->
                    <div class="flex items-center p-3 hover:bg-white rounded-lg transition-colors duration-150">
                      <input 
                        id="user" 
                        v-model="this.user.rules" 
                        type="checkbox" 
                        value="User"  
                        class="h-5 w-5 text-gray-600 border-gray-300 rounded focus:ring-2 focus:ring-gray-500 transition-colors duration-150">
                      <label for="user" class="ml-3 flex-1">
                        <span class="block text-sm font-medium text-gray-900">User</span>
                        <span class="block text-xs text-gray-500">Usuário básico</span>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- Botão Submit -->
                <div class="pt-4">
                  <button 
                    :disabled="disableSubmit" 
                    type="submit"
                    class="w-full flex items-center justify-center gap-2 px-6 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150">
                    <i class="fas" :class="!this.userId ? 'fa-plus' : 'fa-save'"></i>
                    <span>{{ !this.userId ? 'Cadastrar Usuário' : 'Atualizar Usuário' }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import NavigationMenu from '@/components/NavigationMenu';
import NavigationUsers from '@/components/NavigationUsers';
import UserService from '@/services/userService';
import { useToast } from "vue-toastification";

export default {
  name: 'UserForm',
  components: {
    NavigationMenu,
    NavigationUsers
  },
  setup() {
      const toast = useToast();
      return { toast }
  },
  computed: {
    ...mapGetters('user', {
      userProfile: 'userProfile',
    })
  },
  mounted() {
    this.userId = this.$route.params.userId;
    if (this.userId || this.userId.length > 0) {
      UserService.getUser(this.userId).then(data => {
        this.user = data
      }).catch(err => {
        console.log(err);
        this.toast.error("Não foi possível carregar os dados do usuário.");
      })
    }
    
  },
  methods: {
    async submitForm(e) {
      this.disableSubmit = true;
      if (!this.isValidForm()) {
        this.toast.error("Dados do usuario inválidos");
        return true;
      }
      e.preventDefault();

      UserService.saveUser(this.user).then((data) => {
        console.log(data.status);
        this.toast.success("Usuario salvo com sucesso!", {
          onClose: () => {
            this.$router.push('/users');
          }
        });
      }).catch(err => {
        console.log(err);
        this.disableSubmit = false;
        this.toast.error("Não foi possível salvar o usuário.");
      });
    },
    isValidForm() {
      console.log(this.user.name);
      if (this.user.name == undefined || this.user.name.length <= 0) {
        return false;
      }
      return true;
    }

  },
  data(){
    return {
      user: {
        rules: []
      },
      userId: null,
      disableSubmit: false,
    }
  },
}
</script>